import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import { StepsContext } from '../context/StepsContext';
import { useContext } from 'react';
import { useEffect } from 'react';
import DrugRiskComponent from './drugRiskComponent';
import { UtilityComponent } from '@iq-solutions/nida-shared';
import { useParams } from 'react-router-dom';

type UrlParams = {
  drugs: Readonly<string>;
};

const resultsComponent = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  const urlParams = useParams<UrlParams>();
  const [show, setShow] = useState(true);
  let sortDrugScore: Array<[string, number]> = [];
  let riskMap: Array<[string, string]> = [];
  let shareUrlData: string[] = [];

  const drugScore: Record<string, number> = {
    'illicit opioids': 0,
    marijuana: 0,
    opioids: 0,
    'prescription stimulants': 0,
    'illicit stimulants': 0,
    'other drugs': 0,
    tobacco: 0,
    alcohol: 0,
    sedatives: 0,
  };
  const sortedDrugs = [
    'tobacco',
    'alcohol',
    'sedatives',
    'marijuana',
    'illicit stimulants',
    'prescription stimulants',
    'illicit opioids',
    'opioids',
    'other drugs',
  ];
  const sortedRisks = ['high', 'moderate', 'low', 'minimal'];
  for (const value of Object.values(qContext.answers)) {
    if (value.answer !== 'never' && value.answer !== 'no') {
      for (const i of value.drugs) {
        switch (i.toLowerCase()) {
          case 'opioids':
            drugScore.opioids += 1;
            break;
          case 'illicit opioids' || 'heroin':
            drugScore['illicit opioids'] += 1;
            break;
          case 'prescription stimulants':
            drugScore['prescription stimulants'] += 1;
            break;
          case 'illicit stimulants':
            drugScore['illicit stimulants'] += 1;
            break;
          case 'marijuana':
            drugScore.marijuana += 1;
            break;
          case 'other drugs':
            drugScore['other drugs'] += 1;
            break;
          case 'tobacco':
            drugScore.tobacco += 1;
            break;
          case 'alcohol':
            drugScore.alcohol += 1;
            break;
          case 'sedatives':
            drugScore.sedatives += 1;
            break;
        }
      }
    }
  }

  if (drugScore.opioids <= drugScore['illicit opioids']) {
    delete drugScore.opioids;
  } else {
    delete drugScore['illicit opioids'];
  }
  if (drugScore['prescription stimulants'] <= drugScore['illicit stimulants']) {
    delete drugScore['prescription stimulants'];
  } else {
    delete drugScore['illicit stimulants'];
  }

  for (let entry in drugScore) {
    sortDrugScore.push([entry, drugScore[entry]]);
  }

  sortDrugScore.sort(function (a, b) {
    return b[1] - a[1];
  });

  const riskHandler = (temp: [string, number]): void => {
    let drug = temp[0];
    let risk = temp[1];
    switch (true) {
      case risk === 0:
        riskMap.push([drug, 'minimal']);
        break;
      case risk === 1:
        riskMap.push([drug, 'low']);
        break;
      case risk === 2:
        riskMap.push([drug, 'moderate']);
        break;
      case risk > 2:
        riskMap.push([drug, 'high']);
        break;
    }
  };

  if (urlParams.drugs && urlParams.drugs !== '') {
    riskMap = [];
    let parsedParameters = urlParams.drugs.replace(/-/g, ' ').split('+');
    parsedParameters.forEach((e): void => {
      let parsedScore = e.split('=');
      riskMap.push([parsedScore[0], parsedScore[1]]);
    });
  } else {
    for (const drug of sortDrugScore) {
      riskHandler(drug);
    }
  }
  riskMap.sort(function (a, b): any {
    if (sortedRisks.indexOf(a[1]) > sortedRisks.indexOf(b[1])) {
      return 1;
    } else if (sortedRisks.indexOf(a[1]) < sortedRisks.indexOf(b[1])) {
      return -1;
    }
    if (sortedDrugs.indexOf(a[0]) > sortedDrugs.indexOf(b[0])) {
      return 1;
    } else if (sortedDrugs.indexOf(a[0]) < sortedDrugs.indexOf(b[0])) {
      return -1;
    }
    return 0;
  });

  riskMap.forEach((drugRes) => {
    shareUrlData.push(drugRes[0].replace(/\s+/g, '-') + '=' + drugRes[1]);
  });

  useEffect(() => {
    if (qContext.userType === 'patient') {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  const handleClose = (): void => setShow(false);
  return (
    <div className={show ? 'results-component hide' : 'results-component'}>
      <UtilityComponent app="taps2" shareUrl={'/taps2/result/' + shareUrlData.join('+')} />

      <div className="disclaimer">
        <strong>Disclaimer</strong>
        <br />
        The following implications, results and suggested actions are intended to serve as a
        reference guide for practitioners. They DO NOT REPLACE clinical judgement. Not all possible
        clinical scenarios are addressed by this guide. We strongly suggest asking additional
        questions to clarify the patient’s risks to help determine a course of action.
      </div>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>Thank You</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Thank you for taking this survey, please let your health care provider know that it is
            complete.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
      {riskMap.map((drug) => (
        <div key={drug[0]}>
          <DrugRiskComponent drug={drug} />
        </div>
      ))}
    </div>
  );
};
export default resultsComponent;
